'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { CreationWizard } from '@/components/content/CreationWizard';
import { useContent } from '@/contexts/ContentContext';
import { Loader2 } from 'lucide-react';

export default function CreatePage() {
  const router = useRouter();
  const { selectedProjectId } = useContent();
  const [latestDraftId, setLatestDraftId] = useState<string | null>(null);
  const [checked, setChecked] = useState(false);

  // Check for an existing draft to resume
  useEffect(() => {
    const url = selectedProjectId
      ? `/api/content/posts?projectId=${selectedProjectId}&status=draft&limit=1`
      : `/api/content/posts?status=draft&limit=1`;
    fetch(url)
      .then(r => r.json())
      .then(data => {
        const posts = Array.isArray(data) ? data : data.posts || [];
        const draft = posts.find((p: Record<string, string>) => p.topic || p.hook || p.script || p.caption);
        if (draft?.id) setLatestDraftId(draft.id);
      })
      .catch(() => {})
      .finally(() => setChecked(true));
  }, [selectedProjectId]);

  if (!checked) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="w-6 h-6 animate-spin text-cyan-400" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white">
            {latestDraftId ? 'Resume Draft' : 'Create Content'}
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            {latestDraftId
              ? 'Continuing where you left off'
              : 'Build your next post with AI-powered assistance'}
          </p>
        </div>
        {latestDraftId && (
          <button
            onClick={() => setLatestDraftId(null)}
            className="text-xs text-gray-500 hover:text-cyan-400 border border-gray-700 hover:border-cyan-500/40 px-3 py-1.5 rounded-lg transition-all"
          >
            + Start Fresh
          </button>
        )}
      </div>
      <CreationWizard editPostId={latestDraftId || undefined} />
    </div>
  );
}
